import includes from 'lodash/includes';
import { VALIDATION_ERROR_NAME } from '@atlassian/jira-fetch/src/utils/errors';
import type { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import type { Actor, JiraRoleDescription } from '../../common/types';
import type {
	ActorsChildrenProps,
	MergeResponse,
	ActorWithoutRoleDescription,
} from '../actors-api/types';
import { getRenderPropsDataWithoutActors, getIsLastBatch } from '../actors-api/utils';
import type { RoleServiceState, RoleServiceChildrenProps } from '../roles-api/types';

export const refreshActorsAndRolesApi =
	(actorsApi: ActorsChildrenProps, rolesApi: RoleServiceChildrenProps): (() => void) =>
	(): void => {
		if (!actorsApi.loading && !rolesApi.loading) {
			if (actorsApi.error && rolesApi.error) {
				rolesApi.onRefetch();
				actorsApi.refetch();
			} else if (actorsApi.error) {
				actorsApi.refetch();
			} else {
				rolesApi.onRefetch();
			}
		}
	};

export const isValidationError = (validationError: ValidationError): boolean =>
	!!validationError.name && validationError.name === VALIDATION_ERROR_NAME;

export const getMergedActorsAndRolesApi = (
	actorsApi: ActorsChildrenProps,
	rolesApi: RoleServiceState,
): MergeResponse => {
	if (actorsApi.data && rolesApi.data) {
		const { actors, data } = actorsApi;
		// Merge Both responses
		const rolesData: JiraRoleDescription[] = rolesApi.data || [];
		if (Array.isArray(actors) && actors.length && Array.isArray(rolesApi.data)) {
			const actorsWithRoles: Actor[] = actors.map((actor: ActorWithoutRoleDescription): Actor => {
				// For each actor get role detail response
				const { roleIds, ...otherProps } = actor;
				const roles: JiraRoleDescription[] = roleIds
					? rolesData.filter(({ id }) => includes(roleIds, id))
					: [];
				// @ts-expect-error - TS2322 - Type '{ roles: JiraRoleDescription[]; active?: boolean | undefined; displayName?: string | undefined; type?: "atlassian-group-role-actor" | "atlassian-user-role-actor" | "invited-user" | "skeleton-user" | undefined; ... 4 more ...; roleTypeId?: string | undefined; }' is not assignable to type 'Actor'.
				return {
					...otherProps,
					roles,
				};
			});
			const renderProps = getRenderPropsDataWithoutActors(actorsApi);
			// @ts-expect-error - Type '{ actors: Actor[]; isLastBatch: boolean; projectActors?: ProjectActorsQuery_projectActors | null | undefined; }' is not assignable to type 'MergeResponse'.
			return {
				...renderProps.data,
				actors: actorsWithRoles,
				isLastBatch: getIsLastBatch(data),
			};
		}
	}
	const actorsData = actorsApi.data;
	const isLastBatch = !!(
		actorsData &&
		actorsData.projectActors &&
		actorsData.projectActors.isLastBatch
	);
	return {
		// @ts-expect-error - Type '{ actors: never[]; __typename?: "ProjectActorResponse" | undefined; isLastBatch?: boolean | undefined; }' is not assignable to type 'ProjectActorsQuery_projectActors'.
		projectActors: {
			...(actorsData ? actorsData.projectActors : {}),
			actors: [],
		},
		actors: [],
		isLastBatch,
	};
};
